module.exports = __webpack_public_path__ + "img/八大优势.8eed069e.png";